export enum FeatureAppVariantEnum {
	imageBased = 'image-based'
}

export interface AbTestFeatures {
	'360cameraFlight': boolean;
}

export enum TRACKING_TIMER {
	TRIMLINE_SELECTION_NAME = 'trimlineselection_tracking_timer',
	RIM_SELECTION_NAME = 'rimselection_tracking_timer',
	COLOR_SELECTION_NAME = 'colorselection_tracking_timer',
	SCENERY_SELECTION_NAME = 'sceneryselection_tracking_timer',
	PRODUCTVIEW_COLOR_NAME = 'productview_tracking_timer_color',
	PRODUCTVIEW_RIM_NAME = 'productview_tracking_timer_rim',
	PRODUCTVIEW_INTERIOR_NAME = 'productview_tracking_timer_interior',
	PRODUCTVIEW_CARROTATION_NAME = 'productview_tracking_timer_rotation'
}

export interface TrackingNBABInfo {
	itemCount: number;
	itemPosition: number;
}

export interface TrackingLinkInfo {
	url: string;
	// should be provided by hub
	name?: string;
}

export interface TrackingFileInfo {
	name: string;
	type: string;
	url: string;
}

export enum TrackingEventName {
	VISUALIZER_LOAD = 'VWBasic_Visualizer_Load',
	VISUALIZER_INTERACTION = 'VWBasic_VisualizerInteraction_Click',
	VISUALIZER_INTERIOR_LOAD = 'VWBasic_VisualizerInterior_Load',
	VISUALIZER_CTA_CLICK = 'VWBasic_VisualizerCTA_Click',
	VISUALIZER_BASIC_CLICK = 'VWBasic_Button_Click',
	VISUALIZER_BASIC_VEHICLE_BUTTON_CLICK = 'VWBasic_VehicleButton_Click',
	VISUALIZER_BASIC_LAYER_CLOSE_CLICK = 'VWBasic_LayerClose_Click',
	VISUALIZER_NBA_CLICK = 'VWBasic_NBAButton_Click',
	VISUALIZER_COLOR_CLICK = 'VWBasic_VisualizerColor_Click',
	VISUALIZER_WHEELS_CLICK = 'VWBasic_VisualizerWheels_Click',
	VISUALIZER_INTERIOR_CLICK = 'VWBasic_VisualizerInteriorOption_Click',
	VISUALIZER_TRIM_CLICK = 'VWBasic_VisualizerTrim_Click',
	VISUALIZER_CLOSE_CLICK = 'VWBasic_VisualizerClose_Click',
	VISUALIZER_VEHICLE_ZOOM = 'VWBasic_Zoom_Click',
	VISUALIZER_MENU_CLICK = 'VWBasic_VisualizerMenu_Click',
	VISUALIZER_ROTATE_CLICK = 'VWBasic_VisualizerRotate_Click',
	VISUALIZER_SETTINGS_CLICK = 'VWBasic_VisualizerSettings_Click',
	VISUALIZER_FULLSCREEN_OPEN = 'VWBasic_Fullscreen_Open'
}

export const EVENTS_WITH_AB_TEST_FEATURES: ReadonlySet<TrackingEventName> = new Set<TrackingEventName>([
	TrackingEventName.VISUALIZER_LOAD,
	TrackingEventName.VISUALIZER_COLOR_CLICK,
	TrackingEventName.VISUALIZER_WHEELS_CLICK,
	TrackingEventName.VISUALIZER_INTERIOR_CLICK,
	TrackingEventName.VISUALIZER_INTERIOR_LOAD,
	TrackingEventName.VISUALIZER_TRIM_CLICK,
	TrackingEventName.VISUALIZER_ROTATE_CLICK,
	TrackingEventName.VISUALIZER_VEHICLE_ZOOM,
	TrackingEventName.VISUALIZER_MENU_CLICK,
	TrackingEventName.VISUALIZER_NBA_CLICK
]);

export enum ZoomActionTypes {
	UI_INTERACTION = 'UI interaction',
	SCROLL = 'scroll'
}

export enum ContentId {
	IMAGE_BASED_VIEW = 'image_based_view',
	MENU = 'menu',
	INTERIOR_VIEW = '2d-internal-view',
	INTERIOR_CLICK = 'interior-click'
}

export enum ProductView {
	INTERIOR_VIEW = '2d-internal-view',
	EXTERNAL_VIEW = '2d-external-view'
}

interface EquipmentlineTracking {
	EquipmentlineName: string;
}

interface ExteriorTracking {
	ExteriorColorName?: string;
	ExteriorColorCode: string;
}

interface InteriorTracking {
	InteriorColorName?: string;
	InteriorColorCode?: string;
}

interface WheelsTracking {
	WheelsBasicId: string;
	WheelsBasicName?: string;
}

interface CarlineTracking {
	CarlineId: string;
	CarlineName?: string;
}

interface SalesgroupTracking {
	SalesgroupId: string;
	SalesgroupName?: string;
}

interface AngleTracking {
	VehicleAngle: string[];
}

export interface TrackingConfiguration
	extends AngleTracking,
		ExteriorTracking,
		InteriorTracking,
		Partial<EquipmentlineTracking>,
		WheelsTracking,
		CarlineTracking,
		Partial<SalesgroupTracking> {}
